var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{'dark-theme': _vm.$isDarkTheme}],attrs:{"id":"app"}},[(_vm.$route.meta.hiddenLayout)?_c('router-view',{key:_vm.$route.fullPath}):_c('common-layout',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }